import Box from '@mui/material/Box';
import { FormField, FormGrid, InlineFeedback, PrimaryButton } from 'components/forms';
import LoadingOverlay from 'components/UI/LoadingOverlay';
import type React from 'react';
import { useState } from 'react';
import { useUpdatePasswordMutation } from 'services/api/user.api';
import validatePassword from 'utils/validations/validatePassword';

const ChangePassword = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [passwordError, setPasswordError] = useState(false);
  const [passwordConfirmError, setPasswordConfirmError] = useState(false);

  const [updatePassword, { isError, isLoading, isSuccess }] = useUpdatePasswordMutation();

  const passwordVerify = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setNewPassword(event.target.value);
    setPasswordError(!!event.target.value && !validatePassword(event.target.value, ''));
  };

  const passwordConfirmVerify = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setPasswordConfirm(event.target.value);
    setPasswordConfirmError(!!event.target.value && newPassword !== event.target.value);
  };

  const verifyPasswordForm = () => {
    const values = !!currentPassword && !!newPassword && !!passwordConfirm;
    const errors = passwordError || passwordConfirmError;
    return values && !errors;
  };

  const handlePasswordSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (newPassword === passwordConfirm && verifyPasswordForm()) {
      updatePassword({ currentPassword, newPassword }).catch((err: Error) => {
        console.log(err);
      });
    }
  };

  return (
    <Box component="form" onSubmit={handlePasswordSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <LoadingOverlay visible={isLoading} />
      {isError && <InlineFeedback severity="error">Error actualizando la contraseña</InlineFeedback>}
      {isSuccess && <InlineFeedback severity="success">Contraseña actualizada correctamente</InlineFeedback>}

      <FormGrid columns={3}>
        <FormField
          id="password"
          name="password"
          autoComplete="new-password"
          type="password"
          label="Contraseña nueva"
          value={newPassword}
          onChange={passwordVerify}
          error={passwordError ? 'Mínimo 12 caracteres, con mayúscula, minúscula, número y carácter especial' : null}
          required
        />
        <FormField
          id="passwordConfirm"
          name="passwordConfirm"
          type="password"
          label="Confirmar contraseña"
          value={passwordConfirm}
          onChange={passwordConfirmVerify}
          error={passwordConfirmError ? 'Las contraseñas no coinciden' : null}
          required
        />
        <FormField
          id="currentPassword"
          name="currentPassword"
          autoComplete="current-password"
          type="password"
          label="Contraseña actual"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          required
        />
      </FormGrid>

      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <PrimaryButton type="submit" disabled={!verifyPasswordForm() || isLoading}>
          Cambiar contraseña
        </PrimaryButton>
      </Box>
    </Box>
  );
};

export default ChangePassword;
